import { Box } from "@mui/material";

interface NoDataMessageProps {
  heightProp?: string | number; // Ensure type safety
}

const NoDataMessage: React.FC<NoDataMessageProps> = ({ heightProp }) => (
  <Box
    sx={{
      p: 5,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "20px",
      fontWeight: "600",
      textAlign: "center",
      height: heightProp || "50vh", // Default to "100%" if heightProp is not provided
    }}
  >
    No Data Found
  </Box>
);

export default NoDataMessage;